<template>
  <div class="UserEdit-content">
    <section class="UserEdit">
      <div class="UserEdit-container container">
        <h2><span class="bricsa-square"></span>Mis Datos</h2>

        <b-tabs v-model="activeTab">
          <b-tab-item label="Actualiza tus datos">
            <div class="UserEdit-form">
              <div
                role="alert"
                v-show="errors.length > 0"
                v-bind:class="{ show: errors.length }"
                class="alert alert-danger"
              >
                <div class="alert-text" v-for="(error, i) in errors" :key="i">
                  {{ error }}
                </div>
              </div>
              <v-alert v-show="form_show" outlined :type="result_type" text>
                Gracias. Hemos recibido correctamente su solicitud.
                <br />
                Se verá reflejado en cuanto nuestros ejecutivos validen la
                información
              </v-alert>

              <b-form
                class="form-signinx d-flex align-items-stretch flex-column"
                autocomplete="off"
                @submit="onSubmit"
              >
                <div class="row">
                  <div class="form-group col-md-12">
                    <b-form-group label="Nombre">
                      <b-form-input
                        class="form-control"
                        id="info-nombre"
                        name="nombre"
                        v-model="$v.form.nombres.$model"
                        :state="validateState('nombres')"
                        aria-describedby="info-nombre-mensaje-validacion"
                        placeholder="Nombre"
                        type="text"
                        maxLength="75"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback id="info-nombre-mensaje-validacion"
                      >El nombre es obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Apellido Paterno">
                      <b-form-input
                        class="form-control"
                        id="info-apellidoPaterno"
                        name="apellidoPaterno"
                        v-model="$v.form.apellidoPaterno.$model"
                        :state="validateState('apellidoPaterno')"
                        aria-describedby="info-apellidoPaterno-mensaje-validacion"
                        placeholder="Apellido Paterno"
                        type="text"
                        maxLength="75"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback
                      id="info-apellidoPaterno-mensaje-validacion"
                      >El Apellido Paterno es
                      obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Apellido Materno">
                      <b-form-input
                        class="form-control"
                        id="info-apellidoMaterno"
                        name="apellidoMaterno"
                        v-model="$v.form.apellidoMaterno.$model"
                        :state="validateState('apellidoMaterno')"
                        aria-describedby="info-apellidoMaterno-mensaje-validacion"
                        placeholder="Apellido Materno"
                        type="text"
                        maxLength="75"
                        disabled
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-apellidoMaterno-mensaje-validacion"
                      >El Apellido Materno es
                      obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Rut">
                      <b-form-input
                        class="form-control"
                        id="info-rut"
                        name="rut"
                        v-model="$v.form.rut.$model"
                        :state="validateState('rut')"
                        aria-describedby="info-rut-mensaje-validacion"
                        placeholder="rut"
                        type="text"
                        maxLength="10"
                        disabled
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback id="info-rut-mensaje-validacion"
                      >El Rut es obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Celular">
                      <b-form-input
                        class="form-control"
                        id="info-celular"
                        name="telefono"
                        v-model="$v.form.movil.$model"
                        :state="validateState('movil')"
                        aria-describedby="info-movil-mensaje-validacion"
                        placeholder="Celular"
                        type="number"
                        maxLength="9"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-celular-mensaje-validacion"
                      >Celular es obligatorio y no debe superar los 9 dígitos,
                      Ej:991234567</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Email">
                      <b-form-input
                        class="form-control"
                        id="info-email"
                        name="email"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                        aria-describedby="info-email-mensaje-validacion"
                        placeholder="Email"
                        type="email"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback id="info-email-mensaje-validacion"
                      >Email es obligatorio Ej:
                      correo@gmail.com.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Dirección">
                      <b-form-input
                        class="form-control"
                        id="info-direccion"
                        name="direccion"
                        v-model="$v.form.direccion.$model"
                        :state="validateState('direccion')"
                        aria-describedby="info-direccion-mensaje-validacion"
                        placeholder="Dirección"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-direccion-mensaje-validacion"
                      >Dirección es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                </div>
                <b-button @click="onSubmit">Actualizar datos</b-button>
              </b-form>
            </div>
          </b-tab-item>

          <b-tab-item label="Información Laboral">
            <div class="UserEdit-form">
              <div
                role="alert"
                v-show="errors.length > 0"
                v-bind:class="{ show: errors.length }"
                class="alert alert-danger"
              >
                <div class="alert-text" v-for="(error, i) in errors" :key="i">
                  {{ error }}
                </div>
              </div>
              <v-alert v-show="form_show" outlined :type="result_type" text>
                Gracias. Hemos recibido correctamente su solicitud.
                <br />
                Se verá reflejado en cuanto nuestros ejecutivos validen la
                información
              </v-alert>

              <b-form
                class="form-signinx d-flex align-items-stretch flex-column"
                autocomplete="off"
                @submit="onSubmit"
              >
                <div class="row">
                  <div class="form-group col-md-12">
                    <b-form-group label="Profesión">
                      <b-form-input
                        class="form-control"
                        id="info-nombre"
                        name="nombre"
                        v-model="$v.form.profesion.$model"
                        aria-describedby="info-profesion-mensaje-validacion"
                        placeholder="Profesión"
                        type="text"
                        maxLength="75"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback
                      id="info-profesion-mensaje-validacion"
                      >Profesión es obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Cargo">
                      <b-form-input
                        class="form-control"
                        id="info-cargo"
                        name="cargo"
                        v-model="$v.form.cargo.$model"
                        aria-describedby="info-cargo-mensaje-validacion"
                        placeholder="Cargo"
                        type="text"
                        maxLength="75"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback id="info-cargo-mensaje-validacion"
                      >Cargo es obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Empleador">
                      <b-form-input
                        class="form-control"
                        id="info-empleador"
                        name="empleador"
                        v-model="$v.form.empleador.$model"
                        aria-describedby="info-empleador-mensaje-validacion"
                        placeholder="Empleador"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-empleador-mensaje-validacion"
                      >Empleador es obligatorio.</b-form-invalid-feedback
                    >
                  </div>

                  <div class="form-group col-md-12">
                    <b-form-group label="Dirección">
                      <b-form-input
                        class="form-control"
                        id="info-direccion-comercial"
                        name="direccionComercial"
                        v-model="$v.form.direccionComercial.$model"
                        :state="validateState('direccionComercial')"
                        aria-describedby="info-direccionComercial-mensaje-validacion"
                        placeholder="Dirección"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-direccionComercial-mensaje-validacion"
                      >Dirección es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Comuna">
                      <b-form-input
                        class="form-control"
                        id="info-comuna-comercial"
                        name="comunaComercial"
                        v-model="$v.form.comunaComercial.$model"
                        :state="validateState('comunaComercial')"
                        aria-describedby="info-comunaComercial-mensaje-validacion"
                        placeholder="Comuna"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-comunaComercial-mensaje-validacion"
                      >Comuna es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Ciudad">
                      <b-form-input
                        class="form-control"
                        id="info-ciudad-comercial"
                        name="ciudad"
                        v-model="$v.form.ciudadComercial.$model"
                        :state="validateState('ciudadComercial')"
                        aria-describedby="info-ciudad-mensaje-validacion"
                        placeholder="Ciudad"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback id="info-ciudad-mensaje-validacion"
                      >Ciudad es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Fecha último contrato">
                      <b-form-input
                        class="form-control disabled"
                        readonly
                        id="info-fechaContrato-comercial"
                        name="fechaContrato"
                        v-model="computedDateFormattedContrato"
                        :state="validateState('fechaContrato')"
                        aria-describedby="info-fechaContrato-mensaje-validacion"
                        placeholder="Fecha Contrato"
                        type="text"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-fechaContrato-mensaje-validacion"
                      >Fecha contrato es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Renta Familiar">
                      <b-form-input
                        class="form-control"
                        id="info-rentaFamiliar-comercial"
                        name="rentaFammiliar"
                        v-model="$v.form.rentaFamiliar.$model"
                        :state="validateState('rentaFamiliar')"
                        aria-describedby="info-rentaFamiliar-mensaje-validacion"
                        placeholder="Renta Familiar"
                        type="text"
                        maxLength="15"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-rentaFamiliar-mensaje-validacion"
                      >Ciudad es obligatorio</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Entidad Financiera del crédito">
                      <b-form-input
                        class="form-control"
                        id="info-entidadFinanciera-comercial"
                        name="entidadFinanciera"
                        readonly
                        v-model="$v.form.entidadFinancieraCredito.$model"
                        :state="validateState('entidadFinancieraCredito')"
                        aria-describedby="info-entidadFinanciera-mensaje-validacion"
                        placeholder="Entidad Financiera"
                        type="text"
                        maxLength="100"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-entidadFinanciera-mensaje-validacion"
                      >Entidad Financiera es
                      obligatorio</b-form-invalid-feedback
                    >
                  </div>
                </div>
                <b-button @click="onSubmit">Actualizar datos</b-button>
              </b-form>
            </div>
          </b-tab-item>

          <b-tab-item label="Cambiar contraseña">
            <div class="UserEdit-form">
              <div
                role="alert"
                v-show="errors_pass.length > 0"
                v-bind:class="{ show: errors_pass.length }"
                class="alert alert-danger"
              >
                <div
                  class="alert-text"
                  v-for="(error, i) in errors_pass"
                  :key="i"
                >
                  {{ error }}
                </div>
              </div>
              <div class="d-flex align-items-stretch flex-column">
                <div
                  class="alert alert-success messaging"
                  v-show="form_show_pass"
                >
                  <svg
                    data-v-bc4e6392=""
                    viewBox="0 0 16 16"
                    width="1em"
                    height="1em"
                    focusable="false"
                    role="img"
                    aria-label="exclamation circle"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi-exclamation-circle mx-auto b-icon bi"
                  >
                    <g data-v-bc4e6392="">
                      <path
                        fill-rule="evenodd"
                        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                      ></path>
                      <path
                        d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                      ></path>
                    </g>
                  </svg>
                  Su información ha sido cambiada de forma correcta.
                </div>
              </div>
              <b-form
                class="form-signinx d-flex align-items-stretch flex-column"
                @submit.stop.prevent="onSubmit2"
              >
                <!--begin::Form-->

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Contraseña Actual</label>

                      <b-form-input
                        class="form-control"
                        id="contrasenaActual"
                        name="contrasenaActual"
                        v-model="$v.form2.contrasenaActual.$model"
                        :state="validateState2('contrasenaActual')"
                        aria-describedby="contrasenaActual-mensaje-validacion"
                        placeholder="Contraseña Actual"
                        type="password"
                        maxLength="12"
                      ></b-form-input>

                      <b-form-invalid-feedback
                        id="contrasenaActual-mensaje-validacion"
                        >La contraseña actual es
                        obligatoria.</b-form-invalid-feedback
                      >
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Contraseña Nueva</label>

                      <b-form-input
                        class="form-control"
                        id="nuevaContrasena"
                        name="nuevaContrasena"
                        v-model="$v.form2.nuevaContrasena.$model"
                        :state="validateState2('nuevaContrasena')"
                        aria-describedby="nuevaContrasena-mensaje-validacion"
                        placeholder="Nueva Contraseña"
                        type="password"
                        maxLength="12"
                      ></b-form-input>

                      <b-form-invalid-feedback
                        id="nuevaContrasena-mensaje-validacion"
                        >La nueva contraseña es
                        obligatoria.</b-form-invalid-feedback
                      >
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Confirmar Contraseña</label>
                      <b-form-input
                        class="form-control"
                        id="confirmarContrasena"
                        name="confirmarContrasena"
                        v-model="$v.form2.confirmarContrasena.$model"
                        :state="validateState2('confirmarContrasena')"
                        aria-describedby="confirmarContrasena-mensaje-validacion"
                        placeholder="Confirmar Contraseña"
                        type="password"
                        maxLength="12"
                      ></b-form-input>

                      <b-form-invalid-feedback
                        id="confirmarContrasena-mensaje-validacion"
                        >La contraseña no coincide</b-form-invalid-feedback
                      >
                    </div>
                  </div>
                </div>
                <b-button
                  type="submit"
                  ref="btn-Guardar-Contrasena"
                  @click="onSubmit2"
                  >Cambiar contraseña</b-button
                >

                <!--end::Body-->
              </b-form>
              <!--end::Form-->
            </div>
          </b-tab-item>

          <b-tab-item label="Autorizar a Terceros">
            <div class="UserEdit-form">
              <b-form class="form" @submit.stop.prevent="onSubmit3">
                <!--begin::Form-->
                <div
                  role="alert"
                  v-show="errors_tercero.length > 0"
                  v-bind:class="{ show: errors_tercero.length }"
                  class="alert alert-danger"
                >
                  <div
                    class="alert-text"
                    v-for="(error, i) in errors_tercero"
                    :key="i"
                  >
                    {{ error }}
                  </div>
                </div>
                <div class="d-flex align-items-stretch flex-column">
                  <div
                    class="alert alert-success messaging"
                    v-show="form_show_tercero"
                  >
                    <svg
                      data-v-bc4e6392=""
                      viewBox="0 0 16 16"
                      width="1em"
                      height="1em"
                      focusable="false"
                      role="img"
                      aria-label="exclamation circle"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi-exclamation-circle mx-auto b-icon bi"
                    >
                      <g data-v-bc4e6392="">
                        <path
                          fill-rule="evenodd"
                          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        ></path>
                        <path
                          d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                        ></path>
                      </g>
                    </svg>
                    Hemos recibido su solicitud correctamente.
                  </div>
                </div>
                <div class="row">
                  <label for="autorizarTercero" class="autorizarTercero"
                    ><input
                      type="checkbox"
                      name="autorizarTercero"
                      id="autorizarTercero"
                      v-model="habilitaTercero"
                    />
                    Acepto dejar a cargo a una tercera persona para realizar
                    solicitudes y gestionar mi propiedad.</label
                  >
                </div>
                 <b-overlay :show="!habilitaTercero" rounded="sm" :variant="'transparent'" :opacity="'0.85'" :blur="'1px'" spinner-type="none">
                  <div class="row">
                  <div class="form-group col-md-12">
                    <b-form-group label="Unidad">
                      <b-form-select
                        class="form-control"
                        value-field="idProyecto"
                        text-field="proyecto"
                        v-model="$v.form3.proyecto.$model"
                        :options="proyectos"
                        aria-describedby="info-proyectoTercero-mensaje-validacion"
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >Seleccione una opción</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>

                    <b-form-invalid-feedback
                      id="info-proyectoTercero-mensaje-validacion"
                      >Debe seleccionar una opción.</b-form-invalid-feedback
                    >
                  </div>

                  <div class="form-group col-md-12">
                    <b-form-group label="Nombre">
                      <b-form-input
                        class="form-control"
                        id="info-nombre"
                        name="nombre"
                        v-model="$v.form3.nombre.$model"
                        :state="validateState3('nombre')"
                        aria-describedby="info-nombretercero-mensaje-validacion"
                        placeholder="Nombre Tercero"
                        type="text"
                        maxLength="75"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback
                      id="info-nombretercero-mensaje-validacion"
                      >El nombre es obligatorio.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Apellido">
                      <b-form-input
                        class="form-control"
                        id="info-nombre"
                        name="apellido"
                        v-model="$v.form3.apellido.$model"
                        :state="validateState3('apellido')"
                        aria-describedby="info-apellidotercero-mensaje-validacion"
                        placeholder="Apellido"
                        type="text"
                        maxLength="75"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-invalid-feedback
                      id="info-apellidotercero-mensaje-validacion"
                      >El Apellido es obligatorio.</b-form-invalid-feedback
                    >
                  </div>

                  <div class="form-group col-md-12">
                    <b-form-group label="Rut">
                      <b-form-input
                        class="form-control"
                        id="info-rut"
                        name="rut"
                        v-model="$v.form3.rut.$model"
                        :state="validateState3('rut')"
                        aria-describedby="info-rutTercero-mensaje-validacion"
                        placeholder="rut"
                        type="text"
                        maxLength="10"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-rutTercero-mensaje-validacion"
                      >El Rut es obligatorio.</b-form-invalid-feedback
                    >
                  </div>

                  <div class="form-group col-md-12">
                    <b-form-group label="Email">
                      <b-form-input
                        class="form-control"
                        id="info-email"
                        name="email"
                        v-model="$v.form3.email.$model"
                        :state="validateState3('email')"
                        aria-describedby="info-emailTercero-mensaje-validacion"
                        placeholder="Email"
                        type="email"
                        maxLength="75"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-emailTercero-mensaje-validacion"
                      >Email es obligatorio Ej:
                      correo@gmail.com.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Teléfono">
                      <b-form-input
                        class="form-control"
                        id="info-telefono"
                        name="telefono"
                        v-model="$v.form3.telefono.$model"
                        :state="validateState3('telefono')"
                        aria-describedby="info-telefonoTercero-mensaje-validacion"
                        placeholder="Teléfono"
                        type="text"
                        maxLength="9"
                      ></b-form-input
                    ></b-form-group>

                    <b-form-invalid-feedback
                      id="info-telefonoTercero-mensaje-validacion"
                      >Teléfono Tercero es obligatorio Ej:
                      978458547.</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group col-md-12">
                    <b-form-group label="Relación">
                      <b-form-select
                        class="form-control"
                        v-model="$v.form3.relacion.$model"
                        :options="relaciones"
                        aria-describedby="info-relacion-mensaje-validacion"
                      ></b-form-select>
                    </b-form-group>

                    <b-form-invalid-feedback
                      id="info-relacion-mensaje-validacion"
                      >Debe seleccionar una opción.</b-form-invalid-feedback
                    >
                  </div>
                </div>
                <b-button type="submit" ref="btn-Autorizar" @click="onSubmit3"
                  >Autorizar</b-button>
                <!--end::Body-->
                 </b-overlay>
              </b-form>
              <!--end::Form-->
            </div>
          </b-tab-item>
          <b-tab-item label="Mis Terceros">
            <b-table
              :data="terceros"
              :bordered="isBordered"
              :striped="isStriped"
              :narrowed="isNarrowed"
              :hoverable="isHoverable"
              :loading="isLoading"
              :focusable="isFocusable"
              :mobile-cards="hasMobileCards"
            >
              <b-table-column
                field="nombre"
                label="Nombre"
                
                v-slot="props"
              >
                {{ props.row.nombre }}
              </b-table-column>

              <b-table-column
                field="apellidoPaterno"
                label="Apellido"
                
                v-slot="props"
              >
                {{ props.row.apellidoPaterno }}
              </b-table-column>
              <b-table-column
                field="idProyecto"
                label="Unidad"
                
                v-slot="props"
              >
                {{nombreProyecto(props.row) }}
              </b-table-column>
              <b-table-column
                field="idProyecto"
                label="Fecha Creación/Modificación"
                
                v-slot="props"
              >
                {{props.row.fechaModificacion|formatDate }}
              </b-table-column>
              <b-table-column
                field="acciones"
                label="Acciones"
                
                v-slot="props"
              >
                <b-button @click="modificaTercero(props.row)">Editar</b-button>
                <b-button v-if="props.row.vigente" @click="activaTercero(props.row, 0)" type="is-danger" class="actionButton"
                  >Desactivar</b-button
                >
                <b-button v-else type="is-success" @click="activaTercero(props.row, 1)" class="actionButton">Activar</b-button>
              </b-table-column>
            </b-table>
            <b-modal v-model="editarTercero" :width="640">
              <div class="card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Editar (Nombre de tercero)</p>
                  <button
                    type="button"
                    class="delete"
                    @click="editarTercero = false"
                  />
                </header>
                <div class="card-content modal-body">
                  <div class="content">
                    <div class="UserEdit-form">
                      <b-form class="form" @submit.stop.prevent="onSubmit3">
                        <!--begin::Form-->
                        <div
                          role="alert"
                          v-show="errors_tercero.length > 0"
                          v-bind:class="{ show: errors_tercero.length }"
                          class="alert alert-danger"
                        >
                          <div
                            class="alert-text"
                            v-for="(error, i) in errors_tercero"
                            :key="i"
                          >
                            {{ error }}
                          </div>
                        </div>
                        <div class="d-flex align-items-stretch flex-column">
                          <div
                            class="alert alert-success messaging"
                            v-show="form_show_tercero"
                          >
                            <svg
                              data-v-bc4e6392=""
                              viewBox="0 0 16 16"
                              width="1em"
                              height="1em"
                              focusable="false"
                              role="img"
                              aria-label="exclamation circle"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi-exclamation-circle mx-auto b-icon bi"
                            >
                              <g data-v-bc4e6392="">
                                <path
                                  fill-rule="evenodd"
                                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                ></path>
                                <path
                                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                                ></path>
                              </g>
                            </svg>
                            Hemos recibido su solicitud correctamente.
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12">
                            <b-form-group label="Unidad">
                              <b-form-select
									class="form-control"
									value-field="idProyecto"
									text-field="proyecto"
									v-model="$v.form4.proyecto.$model"
									:options="proyectos"
									aria-describedby="info4-proyectoTercero-mensaje-validacion"
								  >
									<template #first>
									  <b-form-select-option :value="null" disabled
										>Seleccione una opción</b-form-select-option
									  >
									</template>
								  </b-form-select>
                            </b-form-group>

                            <b-form-invalid-feedback
								  id="info4-proyectoTercero-mensaje-validacion"
								  >Debe seleccionar una opción.</b-form-invalid-feedback
								>
                          </div>

                          <div class="form-group col-md-12">
                            <b-form-group label="Nombre">
                              <b-form-input
								class="form-control"
								id="info-nombre"
								name="nombre"
								v-model="$v.form4.nombre.$model"
								:state="validateState4('nombre')"
								aria-describedby="info4-nombretercero-mensaje-validacion"
								placeholder="Nombre Tercero"
								type="text"
								maxLength="75"
							  ></b-form-input>
                            </b-form-group>
                            <b-form-invalid-feedback
                              id="info4-nombretercero-mensaje-validacion"
                              >El nombre es
                              obligatorio.</b-form-invalid-feedback
                            >
                          </div>
                          <div class="form-group col-md-12">
                            <b-form-group label="Apellido">
                              <b-form-input
                                class="form-control"
                                id="info-nombre"
                                name="apellido"
                                v-model="$v.form4.apellido.$model"
                                :state="validateState4('apellido')"
                                aria-describedby="info4-apellidotercero-mensaje-validacion"
                                placeholder="Apellido"
                                type="text"
                                maxLength="75"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-invalid-feedback
                              id="info4-apellidotercero-mensaje-validacion"
                              >El Apellido es
                              obligatorio.</b-form-invalid-feedback
                            >
                          </div>

                          <div class="form-group col-md-12">
                            <b-form-group label="Rut">
                              <b-form-input
                                class="form-control"
                                id="info-rut"
                                name="rut"
                                v-model="$v.form4.rut.$model"
                                :state="validateState4('rut')"
                                aria-describedby="info4-rutTercero-mensaje-validacion"
                                placeholder="rut"
                                type="text"
                                maxLength="10"
                              ></b-form-input
                            ></b-form-group>

                            <b-form-invalid-feedback
                              id="info4-rutTercero-mensaje-validacion"
                              >El Rut es obligatorio.</b-form-invalid-feedback
                            >
                          </div>

                          <div class="form-group col-md-12">
                            <b-form-group label="Email">
                              <b-form-input
                                class="form-control"
                                id="info-email"
                                name="email"
                                v-model="$v.form4.email.$model"
                                :state="validateState4('email')"
                                aria-describedby="info4-emailTercero-mensaje-validacion"
                                placeholder="Email"
                                type="email"
                                maxLength="75"
                              ></b-form-input
                            ></b-form-group>

                            <b-form-invalid-feedback
                              id="info4-emailTercero-mensaje-validacion"
                              >Email es obligatorio Ej:
                              correo@gmail.com.</b-form-invalid-feedback
                            >
                          </div>
                          <div class="form-group col-md-12">
                            <b-form-group label="Teléfono">
                              <b-form-input
                                class="form-control"
                                id="info-telefono"
                                name="telefono"
                                v-model="$v.form4.telefono.$model"
                                :state="validateState4('telefono')"
                                aria-describedby="info4-telefonoTercero-mensaje-validacion"
                                placeholder="Teléfono"
                                type="text"
                                maxLength="9"
                              ></b-form-input
                            ></b-form-group>

                            <b-form-invalid-feedback
                              id="info4-telefonoTercero-mensaje-validacion"
                              >Teléfono Tercero es obligatorio Ej:
                              978458547.</b-form-invalid-feedback
                            >
                          </div>
                          <div class="form-group col-md-12">
                            <b-form-group label="Relación">
                              <b-form-select
                                class="form-control"
                                v-model="$v.form4.relacion.$model"
                                :options="relaciones"
                                aria-describedby="info4-relacion-mensaje-validacion"
                              ></b-form-select>
                            </b-form-group>

                            <b-form-invalid-feedback
                              id="info4-relacion-mensaje-validacion"
                              >Debe seleccionar una
                              opción.</b-form-invalid-feedback
                            >
                          </div>
                        </div>
                        <b-button
                          type="submit"
                          ref="btn-Autorizar"
                          @click="onSubmit4"
                          >Actualizar</b-button
                        >

                        <!--end::Body-->
                      </b-form>
                      <!--end::Form-->
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </b-tab-item>
        </b-tabs>
        <!-- <div class="UserEdit-form">
          <div
            role="alert"
            v-show="errors.length > 0"
            v-bind:class="{ show: errors.length }"
            class="alert alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>
          <v-alert v-show="form_show" outlined :type="result_type" text>
            Gracias. Hemos recibido correctamente su solicitud.
            <br />
            Se verá reflejado en cuanto nuestros ejecutivos validen la
            información
          </v-alert>

          <b-form
            class="form-signinx d-flex align-items-stretch flex-column"
            autocomplete="off"
            @submit="onSubmit"
          >
            <div class="row">
              <div class="form-group col-md-12">
                <b-form-group label="Nombre">
                  <b-form-input
                    class="form-control"
                    id="info-nombre"
                    name="nombre"
                    v-model="$v.form.nombres.$model"
                    :state="validateState('nombres')"
                    aria-describedby="info-nombre-mensaje-validacion"
                    placeholder="Nombre"
                    type="text"
                    maxLength="75"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback id="info-nombre-mensaje-validacion"
                  >El nombre es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Apellido Paterno">
                  <b-form-input
                    class="form-control"
                    id="info-apellidoPaterno"
                    name="apellidoPaterno"
                    v-model="$v.form.apellidoPaterno.$model"
                    :state="validateState('apellidoPaterno')"
                    aria-describedby="info-apellidoPaterno-mensaje-validacion"
                    placeholder="Apellido Paterno"
                    type="text"
                    maxLength="75"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback
                  id="info-apellidoPaterno-mensaje-validacion"
                  >El Apellido Paterno es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Apellido Materno">
                  <b-form-input
                    class="form-control"
                    id="info-apellidoMaterno"
                    name="apellidoMaterno"
                    v-model="$v.form.apellidoMaterno.$model"
                    :state="validateState('apellidoMaterno')"
                    aria-describedby="info-apellidoMaterno-mensaje-validacion"
                    placeholder="Apellido Materno"
                    type="text"
                    maxLength="75"
                    disabled
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-apellidoMaterno-mensaje-validacion"
                  >El Apellido Materno es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Rut">
                  <b-form-input
                    class="form-control"
                    id="info-rut"
                    name="rut"
                    v-model="$v.form.rut.$model"
                    :state="validateState('rut')"
                    aria-describedby="info-rut-mensaje-validacion"
                    placeholder="rut"
                    type="text"
                    maxLength="10"
                    disabled
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-rut-mensaje-validacion"
                  >El Rut es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Celular">
                  <b-form-input
                    class="form-control"
                    id="info-celular"
                    name="telefono"
                    v-model="$v.form.movil.$model"
                    :state="validateState('movil')"
                    aria-describedby="info-movil-mensaje-validacion"
                    placeholder="Celular"
                    type="number"
                    maxLength="9"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-celular-mensaje-validacion"
                  >Celular es obligatorio y no debe superar los 9 dígitos,
                  Ej:991234567</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Email">
                  <b-form-input
                    class="form-control"
                    id="info-email"
                    name="email"
                    v-model="$v.form.email.$model"
                    :state="validateState('email')"
                    aria-describedby="info-email-mensaje-validacion"
                    placeholder="Email"
                    type="email"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-email-mensaje-validacion"
                  >Email es obligatorio Ej:
                  correo@gmail.com.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Dirección">
                  <b-form-input
                    class="form-control"
                    id="info-direccion"
                    name="direccion"
                    v-model="$v.form.direccion.$model"
                    :state="validateState('direccion')"
                    aria-describedby="info-direccion-mensaje-validacion"
                    placeholder="Dirección"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-direccion-mensaje-validacion"
                  >Dirección es obligatorio</b-form-invalid-feedback
                >
              </div>
            </div>
            <h2><span class="bricsa-square"></span>Información Laboral</h2>
            <div class="row">
              <div class="form-group col-md-12">
                <b-form-group label="Profesión">
                  <b-form-input
                    class="form-control"
                    id="info-nombre"
                    name="nombre"
                    v-model="$v.form.profesion.$model"
                    aria-describedby="info-profesion-mensaje-validacion"
                    placeholder="Profesión"
                    type="text"
                    maxLength="75"
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback id="info-profesion-mensaje-validacion"
                  >Profesión es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Cargo">
                  <b-form-input
                    class="form-control"
                    id="info-cargo"
                    name="cargo"
                    v-model="$v.form.cargo.$model"
                    aria-describedby="info-cargo-mensaje-validacion"
                    placeholder="Cargo"
                    type="text"
                    maxLength="75"
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback id="info-cargo-mensaje-validacion"
                  >Cargo es obligatorio.</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Empleador">
                  <b-form-input
                    class="form-control"
                    id="info-empleador"
                    name="empleador"
                    v-model="$v.form.empleador.$model"
                    aria-describedby="info-empleador-mensaje-validacion"
                    placeholder="Empleador"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-empleador-mensaje-validacion"
                  >Empleador es obligatorio.</b-form-invalid-feedback
                >
              </div>

              <div class="form-group col-md-12">
                <b-form-group label="Dirección">
                  <b-form-input
                    class="form-control"
                    id="info-direccion-comercial"
                    name="direccionComercial"
                    v-model="$v.form.direccionComercial.$model"
                    :state="validateState('direccionComercial')"
                    aria-describedby="info-direccionComercial-mensaje-validacion"
                    placeholder="Dirección"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-direccionComercial-mensaje-validacion"
                  >Dirección es obligatorio</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Comuna">
                  <b-form-input
                    class="form-control"
                    id="info-comuna-comercial"
                    name="comunaComercial"
                    v-model="$v.form.comunaComercial.$model"
                    :state="validateState('comunaComercial')"
                    aria-describedby="info-comunaComercial-mensaje-validacion"
                    placeholder="Comuna"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-comunaComercial-mensaje-validacion"
                  >Comuna es obligatorio</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Ciudad">
                  <b-form-input
                    class="form-control"
                    id="info-ciudad-comercial"
                    name="ciudad"
                    v-model="$v.form.ciudadComercial.$model"
                    :state="validateState('ciudadComercial')"
                    aria-describedby="info-ciudad-mensaje-validacion"
                    placeholder="Ciudad"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback id="info-ciudad-mensaje-validacion"
                  >Ciudad es obligatorio</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Fecha último contrato">
                  <b-form-input
                    class="form-control disabled"
                    readonly
                    id="info-fechaContrato-comercial"
                    name="fechaContrato"
                    v-model="computedDateFormattedContrato"
                    :state="validateState('fechaContrato')"
                    aria-describedby="info-fechaContrato-mensaje-validacion"
                    placeholder="Fecha Contrato"
                    type="text"
                    maxLength="75"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-fechaContrato-mensaje-validacion"
                  >Fecha contrato es obligatorio</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Renta Familiar">
                  <b-form-input
                    class="form-control"
                    id="info-rentaFamiliar-comercial"
                    name="rentaFammiliar"
                    v-model="$v.form.rentaFamiliar.$model"
                    :state="validateState('rentaFamiliar')"
                    aria-describedby="info-rentaFamiliar-mensaje-validacion"
                    placeholder="Renta Familiar"
                    type="text"
                    maxLength="15"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-rentaFamiliar-mensaje-validacion"
                  >Ciudad es obligatorio</b-form-invalid-feedback
                >
              </div>
              <div class="form-group col-md-12">
                <b-form-group label="Entidad Financiera del crédito">
                  <b-form-input
                    class="form-control"
                    id="info-entidadFinanciera-comercial"
                    name="entidadFinanciera"
                    readonly
                    v-model="$v.form.entidadFinancieraCredito.$model"
                    :state="validateState('entidadFinancieraCredito')"
                    aria-describedby="info-entidadFinanciera-mensaje-validacion"
                    placeholder="Entidad Financiera"
                    type="text"
                    maxLength="100"
                  ></b-form-input
                ></b-form-group>

                <b-form-invalid-feedback
                  id="info-entidadFinanciera-mensaje-validacion"
                  >Entidad Financiera es obligatorio</b-form-invalid-feedback
                >
              </div>
            </div>
            <b-button @click="onSubmit">Actualizar datos</b-button>
          </b-form>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  UPDATE_INFO,
  UPDATE_INFO_PASSWORD,
  LABORAL,
  AGREGAR_TERCERO,
  OBTIENE_TERCEROS
} from "@/core/services/store/auth.module";
import { GET_PROJECTS } from "@/core/services/store/proyecto.module";
import moment from "moment";
moment.locale("es");
export default {
  name: "InformacionPersonal",
  mixins: [validationMixin],
  data() {
    return {
      muestraMisTerceros:true,
      habilitaTercero:false,
      editarTercero: false,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: true,
      isLoading: false,
      hasMobileCards: true,
      form_show: false,
      form_show_pass: false,
      form_show_tercero: false,
      result_type: "success",
      isOpen: false,
      unidades:[],
      relaciones: [
        { value: null, text: "Seleccione una opción" },
        { value: "Esposo (a)", text: "Esposo (a)" },
        { value: "Pareja", text: "Pareja" },
        { value: "Hijo(a)", text: "Hijo(a)" },
        { value: "Arrendatario", text: "Arrendatario" },
        { value: "Nuevo Propietario", text: "Nuevo Propietario" },
      ],
      form: {
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        movil: "",
        email: "",
        direccion: "",
        profesion: "",
        cargo: "",
        empleador: "",
        direccionComercial: "",
        ciudadComercial: "",
        comunaComercial: "",
        fechaContrato: "",
        rentaFamiliar: "",
        entidadFinancieraCredito: "",
      },
      form2: {
        contrasenaActual: "",
        nuevaContrasena: "",
        confirmarContrasena: "",
      },
      form3: {
        rut: "",
        nombre: "",
        apellido: "",
        email: "",
        telefono: null,
        relacion: null,
        proyecto: null,
      },
      form4: {
        idTercero:0,
        idCliente:0,
        rut: "",
        nombre: "",
        apellido: "",
        email: "",
        telefono: null,
        relacion: null,
        proyecto: null,
      },
    };
  },
  validations: {
    form: {
      rut: {
        required,
        minLength: minLength(3),
      },
      nombres: {
        required,
        minLength: minLength(3),
      },
      apellidoPaterno: {
        required,
        minLength: minLength(3),
      },
      apellidoMaterno: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      movil: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      direccion: {
        required,
      },
      profesion: {
        required,
      },
      cargo: {
        required,
      },
      empleador: {
        required,
      },
      direccionComercial: {},
      ciudadComercial: {},
      comunaComercial: {},
      fechaContrato: {
        required,
      },
      
      rentaFamiliar: {},
      entidadFinancieraCredito: {},
    },
    form2: {
      contrasenaActual: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(12),
      },
      nuevaContrasena: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(12),
      },
      confirmarContrasena: {
        required,
        sameAsPassword: sameAs("nuevaContrasena"),
      },
    },
    form3: {
      rut: {
        required,
        minLength: minLength(3),
      },
      nombre: {
        required,
        minLength: minLength(3),
      },
      apellido: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      telefono: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      relacion: {
        required,
      },
      proyecto: {
        required,
      },
    },
    form4: {
      rut: {
        required,
        minLength: minLength(3),
      },
      nombre: {
        required,
        minLength: minLength(3),
      },
      apellido: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      telefono: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      relacion: {
        required,
      },
      proyecto: {
        required,
      },
      idTercero: {
        required,
      },
      idCliente: {
        required,
      },
    },
  },
  filters: {
        formatDate(value) {
        const duration = moment(value).format("DD/MM/yyyy");
        return `${duration}`;
        },

        formatTime(value) {
        const hora = moment(value).format("HH:mm:ss");
        return `${hora}`;
        },
    },
  methods: {
    modificaTercero(tercero) {
      this.$v.form4.rut.$model = tercero.rut;
      this.$v.form4.email.$model = tercero.email;
      this.$v.form4.nombre.$model = tercero.nombre;
      this.$v.form4.apellido.$model = tercero.apellidoPaterno;
      this.$v.form4.telefono.$model = tercero.movil;
      this.$v.form4.relacion.$model = tercero.relacion;
      this.$v.form4.proyecto.$model = tercero.idProyecto;
      this.$v.form4.idTercero.$model = tercero.idTercero;
      this.$v.form4.idCliente.$model = tercero.idCliente;
      this.editarTercero = true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateState2(name) {
      const { $dirty, $error } = this.$v.form2[name];
      return $dirty ? !$error : null;
    },
    validateState3(name) {
      const { $dirty, $error } = this.$v.form3[name];
      return $dirty ? !$error : null;
    },
    validateState4(name) {
      const { $dirty, $error } = this.$v.form3[name];
      return $dirty ? !$error : null;
    },
    getRelations() {
      this.$Progress.start();
      this.$store.dispatch(OBTIENE_TERCEROS, null).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },

    getLaboral() {
      this.$Progress.start();
      this.$store.dispatch(LABORAL, null).then((response) => {
        this.$Progress.finish(), (this.loading = false);
        console.log(response);
        this.$v.form.profesion.$model = response.profesion;
        this.$v.form.empleador.$model = response.empleador;
        this.$v.form.cargo.$model = response.cargo;
        this.$v.form.fechaContrato.$model = response.fechaContrato;
        this.$v.form.direccionComercial.$model = response.direccionComercial;
        this.$v.form.comunaComercial.$model = response.comunaComercial;
        this.$v.form.ciudadComercial.$model = response.ciudadComercial;
        this.$v.form.rentaFamiliar.$model = response.rentaFamiliar;
        this.$v.form.entidadFinancieraCredito.$model =
          response.entidadFinancieraCredito;
      });
    },
    resetForm3() {
      this.form3 = {
        rut: "",
        nombre: "",
        apellido: "",
        email: "",
        telefono: null,
        relacion: null,
        proyecto: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    resetForm4() {
      this.form4 = {
        rut: "",
        nombre: "",
        apellido: "",
        email: "",
        telefono: null,
        relacion: null,
        proyecto: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      //const submitButton = this.$refs["kt_login_signin_submit"];
      //submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const rut = this.$v.form.rut.$model;
      const nombres = this.$v.form.nombres.$model;
      const apellidoPaterno = this.$v.form.apellidoPaterno.$model;
      const apellidoMaterno = this.$v.form.apellidoMaterno.$model;
      const movil = this.$v.form.movil.$model;
      const email = this.$v.form.email.$model;
      const direccion = this.$v.form.direccion.$model;

      const profesion = this.$v.form.profesion.$model;
      const empleador = this.$v.form.empleador.$model;
      const cargo = this.$v.form.cargo.$model;
      const fechaContrato = this.$v.form.fechaContrato.$model;
      const direccionComercial = this.$v.form.direccionComercial.$model;
      const comunaComercial = this.$v.form.comunaComercial.$model;
      const ciudadComercial = this.$v.form.ciudadComercial.$model;
      const rentaFamiliar = this.$v.form.rentaFamiliar.$model;
      const entidadFinancieraCredito = this.$v.form.entidadFinancieraCredito
        .$model;

      const t = this;
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(UPDATE_INFO, {
            email: email,
            rut: rut,
            nombres: nombres,
            apellidoPaterno,
            apellidoMaterno,
            movil,
            direccion,
            profesion,
            cargo,
            empleador,
            direccionComercial,
            comunaComercial,
            ciudadComercial,
            rentaFamiliar,
            entidadFinancieraCredito,
            fechaContrato,
          })
          // go to which page after successfully login
          .then(() => {
            setTimeout(() => {
              window.scrollTo(50, 0);
            }, 100);
            if (t.errors.length == 0) {
              this.form_show = true;
            }
          });

        //submitButton.classList.remove(
        //  "spinner",
        //  "spinner-light",
        //  "spinner-right"
        // );
      }, 500);
    },

    onSubmit2() {
      this.$v.form2.$touch();
      if (this.$v.form2.$anyError) {
        return;
      }
      const claveActual = this.$v.form2.contrasenaActual.$model;
      const confirmacionClave = this.$v.form2.confirmarContrasena.$model;
      const nuevaClave = this.$v.form2.nuevaContrasena.$model;

      const t = this;
      this.$store
        .dispatch(UPDATE_INFO_PASSWORD, {
          claveActual,
          nuevaClave,
          confirmacionClave,
        })
        .then((resultado) => {
          if (t.errors_pass.length == 0) {
            this.form_show_pass = true;
          }
          console.log(resultado);
        })
        .catch(() => {});
    },
    onSubmit3() {
      this.$v.form3.$touch();
      if (this.$v.form3.$anyError) {
        return;
      }
      const nombre = this.$v.form3.nombre.$model;
      const apellidoPaterno = this.$v.form3.apellido.$model;
      const email = this.$v.form3.email.$model;
      const movil = this.$v.form3.telefono.$model;
      const rut = this.$v.form3.rut.$model;
      const relacion = this.$v.form3.relacion.$model;
      const idProyecto = this.$v.form3.proyecto.$model;
      const proyecto = this.proyectos.find((el) => {
        return el.idProyecto == idProyecto ?? {};
      });

      const negocio = proyecto.idNegocio;
      const etapa = ''+proyecto.idEtapa;
      const unidad = parseInt(proyecto.unidad);
      //const btnGuardar = this.$refs["btn-Autorizar"];
      //btnGuardar.classList.add("spinner", "spinner-light", "spinner-right");
      const t = this;
      this.$store
        .dispatch(AGREGAR_TERCERO, {
          idTercero: 0,
          idCliente: 0,
          nombre,
          apellidoPaterno,
          apellidoMaterno: "",
          rut,
          email,
          movil,
          fijo: "",
          relacion,
          idProyecto,
           negocio,
          etapa, 
          unidad,
          vigente:1
        })
        .then((resultado) => {
          this.getRelations();
          if (t.errors_tercero.length == 0) {
            this.form_show_tercero = true;
            this.resetForm3();
          }
          console.log(resultado);
        })
        .catch(() => {
          /* btnGuardar.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );*/
        });
    },
    onSubmit4() {
      this.$v.form4.$touch();
      if (this.$v.form4.$anyError) {
        return;
      }
      const nombre = this.$v.form4.nombre.$model;
      const apellidoPaterno = this.$v.form4.apellido.$model;
      const email = this.$v.form4.email.$model;
      const movil = this.$v.form4.telefono.$model;
      const rut = this.$v.form4.rut.$model;
      const relacion = this.$v.form4.relacion.$model;
      const idProyecto = this.$v.form4.proyecto.$model;
      const idCliente = this.$v.form4.idCliente.$model;
      const idTercero = this.$v.form4.idTercero.$model;
      const proyecto = this.proyectos.find((el) => {
        return el.idProyecto == idProyecto ?? {};
      });

      const negocio = proyecto.idNegocio;
      const etapa = ''+proyecto.idEtapa;
      const unidad = parseInt(proyecto.unidad);
      //const btnGuardar = this.$refs["btn-Autorizar"];
      //btnGuardar.classList.add("spinner", "spinner-light", "spinner-right");
      const t = this;
      this.$store
        .dispatch(AGREGAR_TERCERO, {
          idTercero,
          idCliente,
          nombre,
          apellidoPaterno,
          apellidoMaterno: "",
          rut,
          email,
          movil,
          fijo: "",
          relacion,
          idProyecto,
          negocio,
          etapa, 
          unidad,
          vigente : 1
        })
        .then((resultado) => {
          this.getRelations();
          if (t.errors_tercero.length == 0) {
            this.form_show_tercero = true;
            this.resetForm4();
          }
          console.log(resultado);
        })
        .catch(() => {
          /* btnGuardar.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );*/
        });
    },
    activaTercero(tercero, estado) {
      const nombre = tercero.nombre;
      const apellidoPaterno = tercero.apellidoPaterno;
      const email = tercero.email;
      const movil = tercero.movil;
      const rut = tercero.rut;
      const relacion = tercero.relacion;
      const idProyecto = tercero.idProyecto;
      const idCliente = tercero.idCliente;
      const idTercero = tercero.idTercero;
      const vigente = estado;
      const t = this;
      this.$store
        .dispatch(AGREGAR_TERCERO, {
          idTercero,
          idCliente,
          nombre,
          apellidoPaterno,
          apellidoMaterno: "",
          rut,
          email,
          movil,
          fijo: "",
          relacion,
          idProyecto,
          vigente
        })
        .then((resultado) => {
          this.getRelations();
          if (t.errors_tercero.length == 0) {
            this.form_show_tercero = true;
            this.resetForm4();
          }
          console.log(resultado);
        })
        .catch(() => {
          /* btnGuardar.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );*/
        });
    },
   nombreProyecto(id){
      if (typeof this.projects.proyectos == "undefined") return '';
      let elementos = this.projects.proyectos;
      const unidad = elementos.find((el) => {
        return el.idProyecto == id.idProyecto ?? {};
      });
      return unidad.proyecto;
    }
  },
  beforeUpdate() {},
  mounted() {
    this.getProjects();
    this.getLaboral();
    this.getRelations();
    this.$nextTick(function() {
      console.log("nextTick", this.user);
      this.$v.form.rut.$model = this.user.rut;
      this.$v.form.email.$model = this.user.email;
      this.$v.form.nombres.$model = this.user.nombres;
      this.$v.form.apellidoPaterno.$model = this.user.apellidoPaterno;
      this.$v.form.apellidoMaterno.$model = this.user.apellidoMaterno;
      this.$v.form.movil.$model = this.user.movil;
      this.$v.form.direccion.$model = this.user.direccion;
    });
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
      errors_pass: (state) => state.auth.errors_pass,
      errors_tercero: (state) => state.auth.errors_tercero,
      user: (state) => state.auth.user,
      laboral: (state) => state.auth.laboral,
      terceros: (state) => state.auth.terceros,
      projects: (state) => state.proyecto.projects,
    }),
    proyectos: function() {
      if (typeof this.projects.proyectos == "undefined") return [];
      let elementos = this.projects.proyectos;
      elementos.forEach((item) => {
        item.productoPrincipal = item.productos.find((el) => {
          return el.esPrincipal == true ?? {};
        });
        item.proyecto = `${item.productoPrincipal.tipo} ${item.proyecto} ${item.productoPrincipal.numero}`;
        item.unidad = item.productoPrincipal.numero;
        item.idProyecto = item.etapaNav.idProyecto;
      });
      return elementos;
    },
    computedDateFormattedContrato() {
      var myDate = new Date("1900-01-01T00:00:00Z");
      return this.$v.form.fechaContrato.$model != myDate
        ? moment(this.$v.form.fechaContrato.$model).format("DD/MM/yyyy")
        : "";
    },
     
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
    max-height: 80vh; /* max 80% of the viewport height */
    overflow-y: auto;
  }
.actionButton{
  margin-left: 10px;
}

.desactivate{
  background: #cecece;
  color: #a3a3a3;
}

.autorizarTercero {
  padding: 10px;
  display: flex;
  align-items: center;
  font-weight: bold;
  input {
    margin-right: 10px;
  }
}

.tabs li .is-active a {
  color: #c30c26 !important;
  border-bottom-color: #c30c26 !important;
}
.container {
  padding: 3% 5% !important;
}
.UserEdit-content {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 3% 5%;
  @media screen and(max-width:426px) {
    margin-top: 90px;
  }
}

.UserEdit {
  width: 60%;
  @media screen and(max-width:426px) {
    width: 80%;
  }
  .UserEdit-container {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
    }
    .UserEdit-form {
      display: grid;
      row-gap: 20px;
      .button {
        width: fit-content;
        justify-self: flex-end;
        background-color: var(--bricsa-red);
        color: #fff;
        border-radius: 0;
      }
      .form-group {
        margin-bottom: 10px;
      }
    }
  }
}
.UserPass {
  .UserPass-container {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
    }
    .UserPass-form {
      display: grid;
      row-gap: 20px;
      .button {
        width: fit-content;
        justify-self: flex-end;
        background-color: var(--bricsa-red);
        color: #fff;
        border-radius: 0;
      }
    }
  }
}
.AuthThird {
  .AuthThird-container {
    .card-content {
      .content {
        display: grid;
        row-gap: 10px;
        button {
          background: var(--bricsa-red);
          color: #fff;
          border-radius: 0;
          border: none;
          justify-self: flex-end;
        }
      }
    }
  }
}
</style>
